<template>
  <div>
    <StandardCard :title="title" subheader="INFO" :loading="loading">
      <template v-slot>
        <CardContent v-model="info" />
      </template>
    </StandardCard>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import moment from "moment";

import StandardCard from "@/components/shared/cards/StandardCard.vue";
import CardContent from "@/components/shared/cards/children/CardContent.vue";

export default Vue.extend({
  name: "CheckupInfoCard",
  props: {
    data: {
      type: Object,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    title(): string {
      return this.data?.name;
    },
    info(): Array<any> {
      var data = [
        {
          icon: "mdi-folder-pound-outline",
          title: "Id",
          content: this.data?.id,
        },
        {
          icon: "mdi-account-tie-outline",
          title: "Ansvarlig",
          content: this.data?.task?.assignedToContactPersonPersonFullName,
        },
        {
          icon: "mdi-autorenew",
          title: "Status",
          content: this.data?.completedDate
            ? "Ferdigstilt"
            : "Ikke ferdigstilt",
        },
        {
          icon: "mdi-calendar-alert",
          title: "Frist",
          content: this.data?.task?.deadLine
            ? moment(this.data?.task?.deadLine).format("DD.MM.YYYY")
            : "",
        },
        {
          icon: "mdi-home-city-outline",
          title: "Prosjekt",
          content: this.data?.projectName,
        },
      ];

      //If checkllist is on house then add
      if (this.data?.houseNum) {
        data.push({
          icon: "mdi-office-building-outline",
          title: "Bygg",
          content: this.data?.houseNum,
        });
      }
      //If checkllist is on section then add
      if (this.data?.sectionNum) {
        data.push({
          icon: "mdi-home-outline",
          title: "Seksjon",
          content: this.data?.sectionNum,
        });
      }

      return data;
    },
  },
  components: {
    StandardCard,
    CardContent,
  },
});
</script>
